"use client";

import { slugify, trackNavClick } from "#utils/utils";
import { Button, useColorModeValue } from "@chakra-ui/react";
import React, { ReactNode } from "react";

export const Links = [
  /**
   * Adding/removing also adds a kebab-case link in routes
   * Note: values are slugified to build route paths (e.g. "SOLUTIONS" -> /solutions)
   */
  "SOLUTIONS",
  "HOW IT WORKS",
  "ASSESSMENTS",
  "PRICING",
  "CASE STUDIES",
  "ABOUT US",
  "CONTACT US",
  // "ARTICLES",
  // "PRIVACY",
];
export const HomeLink = () => {
  const linkTextColor = useColorModeValue("gray.200", "gray.700");
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      window.history.pushState({}, "", "/");
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };
  return (
    <Button
      w={"full"}
      variant={{ base: "unstyled", sm: "ghost" }}
      title="TenK Solutions Home Page"
      onClick={handleClick}
      _hover={{
        textDecoration: "none",
        bg: linkTextColor,
      }}
    >
      HOME
    </Button>
  );
};
export const NavLink = ({
  onClose,
  children: link,
  path,
}: {
  onClose?: () => void;
  children: ReactNode;
  path: string;
}) => {
  const linkName = `/${slugify(link as string)}`;
  const isCurrentPage = slugify(link as string) === path;
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname !== linkName + "/") {
      window.history.pushState({}, "", linkName + "/");
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
    // Analytics: nav click
    trackNavClick({
      nav_type: "menu",
      link_text: String(link),
      link_url: linkName,
    });
    if (onClose) onClose();
  };
  return (
    <Button
      w={"full"}
      variant={{ base: "unstyled", sm: "ghost" }}
      colorScheme="colors.brand.primary"
      textAlign={"center"}
      onClick={handleClick}
      title={`Navigate to ${linkName}`}
      isDisabled={isCurrentPage}
    >
      {link}
    </Button>
  );
};
